import AppTheme from './AppTheme';
import HrmTheme from '../HRM/HrmTheme';

export const themedShellRoutes = {
  '/hrm': { PageTheme: HrmTheme },
  '/suppliers': { PageTheme: AppTheme },
  '/price-search': { PageTheme: AppTheme, canvas: true },
  '/search_results': { PageTheme: AppTheme, canvas: true },
};
export const themedShellFor = pathname => themedShellRoutes[pathname] || null;
